import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineLoading3Quarters } from 'react-icons/ai';
import { checkSubscriptionApi, printLogsApi } from '../Http/http';
import classes from "./SuccessPage.module.css";
import Cookies from "js-cookie";

const SuccessPage = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const [msisdn, setMsisdn] = useState(null);
    const [type, setType] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (searchParams.get("msisdn")) {
            setMsisdn(searchParams.get("msisdn"));
            setType(searchParams.get("type"));
        }
    }, [searchParams]);

    const saveLogs = async () => {
        try {
            const response2 = await printLogsApi({ url: window.location.href });
            console.log(response2, 'response2...');
        } catch (error) {
            console.log(error, 'error---');
        }
    }
    useEffect(() => {
        saveLogs();
    }, []);


    useEffect(() => {
        if (!loading && msisdn) {
            const apiInterval = setInterval(() => {
                handleFormSubmission();
            }, 2000);
            return () => {
                clearInterval(apiInterval);
            }
        }
    }, [loading, msisdn]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);
            const response = await checkSubscriptionApi({ msisdn });
            console.log(response, 'response...');
            setLoading(false);

            Cookies.set('msisdn', msisdn, { expires: 30 });
            navigate("/");
        } catch (error) {
            setLoading(false);
            console.log(error, 'error--');
        }
    }

    if (type == "login") {
        return (
            <div className={classes.wrapper}>
                <div className={classes.statusContainer}>
                    <AiOutlineLoading3Quarters className={classes.iconLoading} />
                    <h2>Please Wait...</h2>
                    <p>We are confirming your login request.</p>
                </div>
            </div>
        )
    }
    else {
        return (
            <div className={classes.wrapper}>
                <div className={classes.statusContainer}>
                    <AiOutlineLoading3Quarters className={classes.iconLoading} />
                    <h2>Processing...</h2>
                    <p>Please wait while we verify your subscription.</p>
                </div>
            </div>
        )
    }

}

export default SuccessPage


// 0|rashiGames_callback  | {"url":"https://ke.rashigames.com/redirect?requestid=6b7ec233-662a-4ecd-90a4-a3f9c6ec3765&mfilter_id=1751365255430wpjmb&msisdn=0724480213&message=Failure&error=invalid_traffic"} Front end logs----------->